import { type ComponentProps } from 'react'

import Svg from '~/shared/assets/Svg'

interface Props extends ComponentProps<typeof Svg> {}

const Menu = ({ color = '#313634', ...rest }: Props) => {
  return (
    <Svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_330_53640)">
        <path
          d="M4 24H28V21.3333H4V24ZM4 17.3333H28V14.6667H4V17.3333ZM4 8V10.6667H28V8H4Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_330_53640">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </Svg>
  )
}

export default Menu
